import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';

@Component({
    selector: 'skl-document-value-box-component',
    templateUrl: './document-value-box.component.html',
    styleUrls: ['./document-value-box.component.scss'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentValueBoxComponent {
    public readonly value = input<string | undefined>();
    public readonly displayVatTable = input(true, { transform: booleanAttribute });
    public readonly showVatTable = output<null>();

    public click(): void {
        this.showVatTable.emit(null);
    }
}
